import { notification } from "antd";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "./init";

export const getBackupDocId = (userInfo = {}) => {
    const rawNameObj =
        userInfo && typeof userInfo.name === "object" && userInfo.name !== null
            ? userInfo.name
            : null;
    const rawFullName =
        rawNameObj?.fullName ||
        (typeof userInfo?.name === "string" ? userInfo.name : "") ||
        userInfo?.displayName ||
        "";
    const parts = String(rawFullName).trim().split(/\s+/).filter(Boolean);
    const firstName = rawNameObj?.firstName || parts[0] || "User";
    const lastName = rawNameObj?.lastName ?? parts.slice(1).join("-");
    const uid =
        userInfo?.uid ||
        userInfo?.id ||
        userInfo?._id ||
        userInfo?.googleId ||
        userInfo?.email ||
        "anonymous";
    return `${firstName}-${lastName}-${uid}`;
};

export const performBackup = async (
    collectionName,
    userInfo,
    portfolios,
    assets,
    settings,
    options = {}
) => {
    const { silent = false, wallets } = options;
    if (!silent) {
        notification.info({
            message: "In progress",
            description: "Syncing your data",
            key: "backup-in-progress",
        });
    }
    const docName = getBackupDocId(userInfo);
    const updatedAt = Number(settings?.lastBackup) || Date.now();
    const payload = {
        username:
            userInfo?.uid || userInfo?.id || userInfo?.email || "anonymous",
        name: userInfo?.name || userInfo?.displayName || "User",
        email: userInfo?.email || "",
        picture: userInfo?.picture || userInfo?.photoURL || "",
        portfolios,
        assets,
        settings,
        updatedAt,
    };
    if (Array.isArray(wallets)) {
        payload.wallets = wallets;
    }
    try {
        await setDoc(doc(db, collectionName, docName), payload, {
            merge: true,
        });
        if (!silent) {
            notification.close("backup-in-progress");
            notification.success({
                message: "Done",
                description: "Synced up!",
            });
        }
    } catch (e) {
        console.error("Error backing up ", e);
        if (silent) {
            throw e;
        }
    }
};

export const fetchBackup = async (collectionName, userInfo, options = {}) => {
    const { silent = false } = options;
    if (!silent) {
        notification.info({
            info: "In progress",
            message: "Fetching cloud data",
            key: "fetch-backup-inprogress",
        });
    }
    const docName = getBackupDocId(userInfo);

    const docRef = doc(db, collectionName, docName);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        if (!silent) {
            notification.close("fetch-backup-inprogress");
            notification.success({
                message: "Sync complete!",
                description:
                    "Found your data on cloud, your local data has been updated.",
            });
        }
        return docSnap.data();
    }
    if (!silent) {
        notification.close("fetch-backup-inprogress");
        notification.info({
            message: "Ah Snap!",
            description: "No backup to Sync!",
        });
    }
    return null;
};
